const SIGN_UP_EXPERIMENT_ID = "Pc9NE0MXQbO-Rrlok1w2ig";

export { SIGN_UP_EXPERIMENT_ID };
